(function($) {
	$(document).ready(function() {
		if ($('#overallMaturityGauge').length) {
			// DEBUG: Set to true to enable verbose logging
			const GAUGE_DEBUG = true;
			
			// Track animation state to detect glitches
			let expectedMaxValue = 0;
			let animationInProgress = false;
			
			// Function to get the VISIBLE gauge card container
			function getVisibleGaugeCard() {
				const $allGaugeCards = $('.row.gauge');
				
				let $visibleCard = null;
				$allGaugeCards.each(function() {
					const $card = $(this);
					if ($card.is(':visible') && !$card.hasClass('d-none')) {
						$visibleCard = $card;
						return false;
					}
				});
				
				if (!$visibleCard) {
					$visibleCard = $('#overallMaturityGauge').closest('.row.gauge');
				}
				
				return $visibleCard;
			}

			// Loading overlay functions
			function showGaugeLoader() {
				const $visibleCard = getVisibleGaugeCard();
				const $overlay = $visibleCard.find('.gauge-loading-overlay');
				const $content = $visibleCard.find('.gauge-content');
				if ($overlay.length) {
					$overlay.addClass('active');
					$content.addClass('loading');
				}
			}

			function hideGaugeLoader() {
				const $visibleCard = getVisibleGaugeCard();
				const $overlay = $visibleCard.find('.gauge-loading-overlay');
				const $content = $visibleCard.find('.gauge-content');
				if ($overlay.length) {
					$overlay.removeClass('active');
					$content.removeClass('loading');
				}
			}
			
			// List of possible selectors in order of priority
			const possibleSelectors = [
				'.crf-maturitylevel-overall',
				'.crf-domain-overall',
				'.crf-legacy-domain-overall',
				'.core-functions-overall-value',
				'.audit-overall-value',
				'[class*="-overall-value"]'
			];

			function findScoreSelector() {
				for (let i = 0; i < possibleSelectors.length; i++) {
					const selector = possibleSelectors[i];
					const element = $(selector);
					if (element.length > 0) {
						if (GAUGE_DEBUG) /* console.log('[findScoreSelector] Using:', selector); */ ;
						return selector;
					}
				}
				//console.error('Could not find any score element!');
				return null;
			}

			let scoreSelector = findScoreSelector();

			function getCurrentProjectIdFromBody() {
				const match = String(document.body.className || '').match(/\bpostid-(\d+)\b/);
				return match ? match[1] : null;
			}

			function isCompletedProjectPage() {
				return $('body').hasClass('single-projects') && $('.project-content').hasClass('project-completed');
			}

			function applyCompletedProjectScore(score) {
				const parsed = parseFloat(score);
				if (Number.isNaN(parsed)) {
					return null;
				}

				const formatted = parsed.toFixed(2);
				const $visibleCard = getVisibleGaugeCard();
				$visibleCard.find('#overall-maturity-score').text(formatted);

				[
					'.audit-overall-value',
					'.crf-maturitylevel-overall',
					'.crf-domain-overall',
					'.crf-legacy-domain-overall',
					'.core-functions-overall-value'
				].forEach(function(selector) {
					const $targets = $(selector);
					if ($targets.length) {
						$targets.text(formatted);
					}
				});

				if (window.WebAssessmentCharts) {
					window.WebAssessmentCharts.calculatedOverallMaturityScore = parsed;
				}

				return parsed;
			}

			function fetchCompletedProjectScore() {
				if (!isCompletedProjectPage()) {
					return Promise.resolve(null);
				}

				const projectId = getCurrentProjectIdFromBody();
				if (!projectId) {
					return Promise.resolve(null);
				}

				if (typeof window.getMarkedCompleteDataPromise === 'function') {
					return window.getMarkedCompleteDataPromise(projectId)
						.then(function(data) {
							return applyCompletedProjectScore(data && data.OverallMaturityScore);
						})
						.catch(function(error) {
							if (GAUGE_DEBUG) console.warn('[gauge] Completed score lookup failed:', error);
							return null;
						});
				}

				const nonce = window.projectDashboardNonce && window.projectDashboardNonce.nonce;
				const ajaxUrl = (window.ajax_object && window.ajax_object.ajax_url) || '/wp-admin/admin-ajax.php';
				if (!nonce) {
					return Promise.resolve(null);
				}

				return $.ajax({
					url: ajaxUrl,
					type: 'GET',
					data: {
						action: 'get_marked_complete_data',
						project_id: projectId,
						nonce: nonce
					},
					timeout: 30000
				}).then(function(response) {
					if (response && response.success && response.data) {
						return applyCompletedProjectScore(response.data.OverallMaturityScore);
					}
					return null;
				}).catch(function(error) {
					if (GAUGE_DEBUG) console.warn('[gauge] Completed score AJAX failed:', error);
					return null;
				});
			}
			
			const gaugeNeedle = {
				id: 'gaugeNeedle',
				afterDatasetsDraw: (chart) => {
					const { ctx } = chart;
					const needleValue = chart.needleValue; // Use a custom property on the chart object

					if (needleValue === undefined || needleValue === null) {
						return;
					}
					
					// GLITCH DETECTION: Log if needle value exceeds expected max during animation
					if (animationInProgress && needleValue > expectedMaxValue + 1) {
						//console.warn('🚨 GLITCH DETECTED in gaugeNeedle: needleValue', needleValue, 'exceeds expected max', expectedMaxValue);
					}

					ctx.save();

					const xCenter = chart.getDatasetMeta(0).data[0].x;
					const yCenter = chart.getDatasetMeta(0).data[0].y;
					const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
					
					// Move the needle base up to be more centered in the semi-circle
					const needleYCenter = yCenter - (outerRadius * 0.1);

					// For a bottom semi-circle (gauge from 9 o'clock to 3 o'clock):
					// 0% score should be at 180 degrees (Math.PI).
					// 100% score should be at 360/0 degrees (2 * Math.PI).
					const angle = -Math.PI + (needleValue / 100) * Math.PI;

					const needleLength = outerRadius * 0.8; // Adjust length to not go past the edge
					const needleTipX = xCenter + needleLength * Math.cos(angle);
					const needleTipY = yCenter + needleLength * Math.sin(angle); // Use original yCenter for arc calculation
					const needleBaseRadius = 10;
					
					// Draw the large light grey circle base
					ctx.beginPath();
					ctx.arc(xCenter, needleYCenter, needleBaseRadius * 1.5, 0, 2 * Math.PI);
					ctx.fillStyle = '#E0E0E0';
					ctx.fill();
					
					// Points for the base of the needle triangle
					const perpAngle = angle + Math.PI / 2;
					const baseP1X = xCenter + needleBaseRadius * Math.cos(perpAngle);
					const baseP1Y = needleYCenter + needleBaseRadius * Math.sin(perpAngle);
					const baseP2X = xCenter - needleBaseRadius * Math.cos(perpAngle);
					const baseP2Y = needleYCenter - needleBaseRadius * Math.sin(perpAngle);
					
					// Draw dark needle shape (triangle)
					ctx.beginPath();
					ctx.moveTo(needleTipX, needleTipY);
					ctx.lineTo(baseP1X, baseP1Y);
					ctx.lineTo(baseP2X, baseP2Y);
					ctx.closePath();
					ctx.fillStyle = '#444444';
					ctx.fill();

					// Draw dark circle on top to create rounded base
					ctx.beginPath();
					ctx.arc(xCenter, needleYCenter, needleBaseRadius, 0, 2 * Math.PI);
					ctx.fillStyle = '#444444';
					ctx.fill();

					// Draw small circle in the middle for the "hole"
					ctx.beginPath();
					ctx.arc(xCenter, needleYCenter, 4, 0, 2 * Math.PI);
					ctx.fillStyle = '#E0E0E0';
					ctx.fill();
					
					ctx.restore();
				}
			};

			const solidColors = ['#ff6d6e', '#eec068', '#33c851'];
			const bandNames = ['Developing Capability', 'Established Capability', 'Advanced Capability'];
			// Tooltip footer naming what the bands are based on. Peer bands set it
			// (benchmark-compare.js); for the standard bands only site admins see
			// one (owner's call, crfBenchmarkCompare.isAdmin).
			let bandSource = null;
			function bandFooter() {
				if (bandSource) {
					return bandSource;
				}
				return (window.crfBenchmarkCompare && window.crfBenchmarkCompare.isAdmin === '1') ? 'Based on all completed assessments' : [];
			}

			// A band's bounds on the 0-5 scale, read off the drawn ranges so the
			// tooltip always matches the arcs (global or peer bands).
			function bandInfo(index) {
				const ranges = gaugeDataPlugin.ranges;
				let from = 0;
				for (let i = 0; i < index; i++) {
					from += ranges[i];
				}
				return {
					name: bandNames[index] || '',
					from: (from / 100) * 5,
					to: ((from + ranges[index]) / 100) * 5
				};
			}

			const lightColors = ['rgba(255, 109, 110, 0.3)', 'rgba(238, 192, 104, 0.3)', 'rgba(51, 200, 81, 0.3)'];

			const gaugeDataPlugin = {
				id: 'gaugeData',
				ranges: [33, 33, 34], // Default ranges
				beforeUpdate: (chart) => {
					const ranges = gaugeDataPlugin.ranges;
					const score = chart.needleValue || 0;
					
					// GLITCH DETECTION: Log if score exceeds expected max during animation
					if (animationInProgress && score > expectedMaxValue + 1) {
						//console.warn('🚨 GLITCH DETECTED in beforeUpdate: score', score, 'exceeds expected max', expectedMaxValue);
						//console.warn('  chart.needleValue:', chart.needleValue);
						//console.trace('Stack trace for glitch');
					}
					
					if (GAUGE_DEBUG) {
						//console.log('[beforeUpdate] score:', score, 'expectedMax:', expectedMaxValue);
					}
					
					// Dataset 0 (background): Always shows full ranges in light colors - STATIC
					chart.data.datasets[0].data = [...ranges];
					chart.data.datasets[0].backgroundColor = [...lightColors];
					
					// Dataset 1 (foreground): Shows progress based on needleValue - ANIMATES
					const foregroundData = [];
					const foregroundColors = [];
					let scoreRemaining = score;

					for (let i = 0; i < ranges.length; i++) {
						const rangeSize = ranges[i];

						if (scoreRemaining <= 0) {
							foregroundData.push(rangeSize);
							foregroundColors.push('transparent');
						} else if (scoreRemaining >= rangeSize) {
							foregroundData.push(rangeSize);
							foregroundColors.push(solidColors[i]);
							scoreRemaining -= rangeSize;
						} else {
							foregroundData.push(scoreRemaining);
							foregroundColors.push(solidColors[i]);
							foregroundData.push(rangeSize - scoreRemaining);
							foregroundColors.push('transparent');
							scoreRemaining = 0;
						}
					}

					chart.data.datasets[1].data = foregroundData;
					chart.data.datasets[1].backgroundColor = foregroundColors;
				}
			};
			
			// Plugin to force Dataset 1 (foreground) to overlay exactly on Dataset 0 (background)
			let coordLogCount = 0;
			const overlayPlugin = {
				id: 'overlayDatasets',
				beforeDatasetDraw: (chart, args) => {
					const datasetIndex = args.index;
					
					// Only modify Dataset 1 (foreground) to match Dataset 0's radius
					if (datasetIndex === 1) {
						const meta0 = chart.getDatasetMeta(0);
						const meta1 = chart.getDatasetMeta(1);
						
						if (meta0.data && meta0.data.length > 0 && meta1.data && meta1.data.length > 0) {
							// Get the radius values from Dataset 0
							const targetInnerRadius = meta0.data[0].innerRadius;
							const targetOuterRadius = meta0.data[0].outerRadius;
							
							// Apply same radius to all arcs in Dataset 1
							meta1.data.forEach(arc => {
								arc.innerRadius = targetInnerRadius;
								arc.outerRadius = targetOuterRadius;
							});
							
							// Log for debugging (first few times only)
							coordLogCount++;
							if (GAUGE_DEBUG && coordLogCount <= 3) {
								//console.log('=== Overlay Applied (draw #' + coordLogCount + ') ===');
								//console.log('Dataset 0 radius:', { inner: targetInnerRadius, outer: targetOuterRadius });
								//console.log('Dataset 1 radius (after override):', { 
								//	inner: meta1.data[0].innerRadius, 
								//	outer: meta1.data[0].outerRadius 
								//});
							}
						}
					}
				},
				afterDraw: (chart) => {
					// Debug logging for coordinates
					if (!GAUGE_DEBUG || coordLogCount > 5) return;
					
					//console.log('=== Final Dataset Coordinates ===');
					for (let dsIndex = 0; dsIndex < chart.data.datasets.length; dsIndex++) {
						const meta = chart.getDatasetMeta(dsIndex);
						if (meta.data && meta.data.length > 0) {
							const firstArc = meta.data[0];
							//console.log(`Dataset ${dsIndex}:`, {
							//	x: firstArc.x,
							//	y: firstArc.y,
							//	innerRadius: firstArc.innerRadius,
							//	outerRadius: firstArc.outerRadius
							//});
						}
					}
				}
			};


			// Function to create a FRESH chart config each time to avoid stale data
			function createChartConfig() {
				if (GAUGE_DEBUG) /* console.log('[createChartConfig] Creating fresh config'); */ ;
				
				// Reset coord log count for new chart
				coordLogCount = 0;
				
				return {
					type: 'doughnut',
					data: {
						datasets: [
							// Dataset 0: Background (light colors) - static, always shows full range
							{
								data: [], // Will be populated by plugin
								backgroundColor: [],
								borderWidth: 4,
								borderColor: '#fff',
								borderRadius: 20,
								spacing: 0,
							},
							// Dataset 1: Foreground (solid colors) - animates with needle
							{
								data: [], // Will be populated by plugin
								backgroundColor: [],
								borderWidth: 0,
								borderColor: 'transparent',
								borderRadius: 20,
								spacing: 0,
							}
						]
					},
					options: {
						rotation: 270,
						circumference: 180,
						cutout: '75%',
						// IMPORTANT: Disable Chart.js built-in animations to prevent flash
						animation: false,
						// Hovering a band shows its score range. Dataset 1 (the animated
						// foreground) sits on the same arcs, so only dataset 0 answers.
						interaction: { mode: 'point', intersect: true },
						onHover: function(event, elements, chart) {
							chart.canvas.style.cursor = elements.length ? 'help' : '';
						},
						plugins: {
							legend: { display: false },
							tooltip: {
								enabled: true,
								filter: function(item) { return item.datasetIndex === 0; },
								displayColors: false,
								callbacks: {
									title: function(items) { return items.length ? bandInfo(items[0].dataIndex).name : ''; },
									label: function(item) {
										const band = bandInfo(item.dataIndex);
										return 'Score ' + band.from.toFixed(2) + ' – ' + band.to.toFixed(2);
									},
									footer: function() { return bandFooter(); }
								}
							}
						},
						maintainAspectRatio: false,
					},
					plugins: [gaugeDataPlugin, gaugeNeedle, overlayPlugin]
				};
			}

			// Track the current chart instance and canvas
			let gaugeChart = null;
			let currentChartCanvas = null;
			let animationFrameId = null;

			// Function to create or recreate the chart on the visible canvas
			function ensureChartOnVisibleCanvas() {
				const $visibleCard = getVisibleGaugeCard();
				const visibleCanvas = $visibleCard.find('#overallMaturityGauge')[0] || $visibleCard.find('canvas')[0];
				
				if (!visibleCanvas) {
					//console.error('No canvas found in visible gauge card!');
					return false;
				}
				
				// If chart is already on the visible canvas, no need to recreate
				if (visibleCanvas === currentChartCanvas && gaugeChart) {
					return true;
				}
				
				if (GAUGE_DEBUG) /* console.log('[ensureChart] Creating/recreating chart on new canvas'); */ ;
				
				// Destroy existing chart if it exists
				if (gaugeChart) {
					if (GAUGE_DEBUG) {
						//console.log('[ensureChart] Destroying old chart');
						//console.log('[ensureChart] Old dataset 0:', JSON.stringify(gaugeChart.data.datasets[0].data));
						//console.log('[ensureChart] Old dataset 1:', JSON.stringify(gaugeChart.data.datasets[1].data));
					}
					gaugeChart.destroy();
					gaugeChart = null;
				}
				
				// Create new chart on the visible canvas with FRESH config
				const freshConfig = createChartConfig();
				gaugeChart = new Chart(visibleCanvas, freshConfig);
				
				// GLITCH CHECK: Log if needleValue is unexpectedly set after creation
				if (gaugeChart.needleValue !== undefined && gaugeChart.needleValue !== 0) {
					//console.warn('🚨 GLITCH: Chart created with unexpected needleValue:', gaugeChart.needleValue);
				}
				
				// Log the initial data state
				if (GAUGE_DEBUG) {
					//console.log('[ensureChart] New chart created');
					//console.log('[ensureChart] Dataset 0:', JSON.stringify(gaugeChart.data.datasets[0].data));
					//console.log('[ensureChart] Dataset 1:', JSON.stringify(gaugeChart.data.datasets[1].data));
				}
				
				gaugeChart.needleValue = 0;
				currentChartCanvas = visibleCanvas;
				
				return true;
			}

			// Initialize the chart on the first visible canvas
			ensureChartOnVisibleCanvas();

			function updateGauge(score) {
				//console.log('[updateGauge] Starting animation to score:', score);

				// Ensure chart is on the visible canvas before updating
				if (!ensureChartOnVisibleCanvas()) {
					//console.error('Could not ensure chart on visible canvas, aborting update');
					return;
				}

				if (animationFrameId) {
					if (GAUGE_DEBUG) /* console.log('[updateGauge] Cancelling previous animation'); */ ;
					cancelAnimationFrame(animationFrameId);
					animationFrameId = null;
				}

				const scaledScore = (score / 5) * 100;
				const targetScore = Math.max(0, Math.min(100, scaledScore));
				
				// Set expected max for glitch detection
				expectedMaxValue = targetScore;
				animationInProgress = true;
				
				// Reset needle to 0 before starting animation
				gaugeChart.needleValue = 0;
				
				// Animate the needle AND foreground layer from 0 to target
				const startScore = 0;
				const duration = 1500;
				let startTime = null;

				function animationStep(timestamp) {
					if (!startTime) {
						startTime = timestamp;
					}

					const elapsed = timestamp - startTime;
					const progress = Math.min(elapsed / duration, 1);
					const easedProgress = 1 - Math.pow(1 - progress, 3);
					const animatedScore = startScore + (targetScore - startScore) * easedProgress;

					gaugeChart.needleValue = animatedScore;
					gaugeChart.update('none');

					if (progress < 1) {
						animationFrameId = requestAnimationFrame(animationStep);
					} else {
						animationInProgress = false;
						//console.log('[updateGauge] Animation complete, final value:', gaugeChart.needleValue.toFixed(2));
					}
				}

				animationFrameId = requestAnimationFrame(animationStep);
			}

			function updateScoreDisplay(score, benchmarkData) {
				if (GAUGE_DEBUG) /* console.log('[updateScoreDisplay] score:', score); */ ;
				
				// Get the VISIBLE gauge card fresh each time
				const $gaugeCard = getVisibleGaugeCard();
				
				// Scope all lookups to the gauge card container
				const scoreElement = $gaugeCard.find('#overall-maturity-score')[0];
				if (scoreElement) {
					scoreElement.textContent = parseFloat(score).toFixed(2);
				}

				const scoreContainer = $gaugeCard.find('.overall-score');
				if (scoreContainer.length) {
					let color = solidColors[2]; // Default to green
					if (score <= benchmarkData.belowAverage) {
						color = solidColors[0];
					} else if (score <= benchmarkData.average) {
						color = solidColors[1];
					}
					scoreContainer.css('color', color);
				}

				const descriptionSpan = $gaugeCard.find('.overall-score-description');
				const titleContainer = $gaugeCard.find('#overall-maturity-title-container');
				const titleSpan = $gaugeCard.find('#overall-maturity-title');
				
				const titles = {
					belowAverage: 'Developing Capability',
					average: 'Established Capability',
					aboveAverage: 'Advanced Capability'
				};

				const descriptions = {
					belowAverage: 'Current safeguards function inconsistently and remain below the capability level typically demonstrated by peer organizations, indicating a high priority for improvement.',
					average: 'Safeguards function reliably across most areas and reflect capabilities commonly found among peer organizations, though targeted improvements remain a priority to strengthen consistency and resilience.',
					aboveAverage: 'Safeguards operate with strong consistency and exceed the capability levels typically observed among peer organizations, however, additional, strategic improvements should be considered.'
				};

				if (descriptionSpan.length && titleContainer.length) {
					let text = 'established';
					let title = titles.average;
					let description = descriptions.average;
					let color = solidColors[1];

					if (score <= benchmarkData.belowAverage) {
						text = 'developing';
						title = titles.belowAverage;
						description = descriptions.belowAverage;
						color = solidColors[0];
					} else if (score >= benchmarkData.aboveAverage) {
						text = 'advanced';
						title = titles.aboveAverage;
						description = descriptions.aboveAverage;
						color = solidColors[2];
					}

					// Update the article "a" or "an" - scoped to gauge card
					const articleSpan = $gaugeCard.find('.article');
					if (['advanced', 'established'].includes(text)) {
						articleSpan.text('an');
					} else {
						articleSpan.text('a');
					}

					descriptionSpan.text(text);
					descriptionSpan.css('color', color);
					$gaugeCard.find('#capability-details').text(description);
					titleSpan.text(title);

					// Remove existing tooltip if it exists
					const existingTooltip = titleContainer.find('.info-tooltip');
					if (existingTooltip.length) {
						existingTooltip.remove();
					}

					const tooltipIcon = $('<span class="info-tooltip" data-bs-toggle="tooltip" data-bs-placement="top"> <i class="fas fa-info-circle"></i></span>').attr('title', benchmarkTooltip);
					titleContainer.append(tooltipIcon);

					// Re-initialize tooltips within the gauge card
					$gaugeCard.find('[data-bs-toggle="tooltip"]').tooltip();
				}
			}

			let benchmarkData = null;
			// The all-projects bands, kept so a peer comparison can be undone.
			let globalBenchmarkData = null;
			const defaultTooltip = 'These maturity classifications are based on benchmarked ranges derived from historical assessment data.';
			let benchmarkTooltip = defaultTooltip;

			// Re-band the gauge (p33 / p66 on the 0-5 scale) and redraw at the current score.
			// Pill after the score while peer bands are applied, so it's clear the
			// gauge reflects the comparison. Every gauge card gets it, since the
			// visible card changes with the dashboard dropdown.
			function setPeerPill(on) {
				$('.row.gauge .overall-score .benchmark-gauge-pill').remove();
				if (on) {
					$('.row.gauge .overall-score').append(
						'<span class="benchmark-gauge-pill"><i class="fas fa-users" aria-hidden="true"></i>Compared with peers</span>'
					);
				}
			}

			function applyBenchmarkBands(bands, tooltip, source) {
				benchmarkData = bands;
				benchmarkTooltip = tooltip || defaultTooltip;
				bandSource = source || null;
				setPeerPill(!!source);
				const belowAveragePercent = (bands.belowAverage / 5) * 100;
				const averagePercent = (bands.average / 5) * 100;
				gaugeDataPlugin.ranges = [belowAveragePercent, averagePercent - belowAveragePercent, 100 - averagePercent];
				const score = parseFloat(getVisibleGaugeCard().find('#overall-maturity-score').text());
				if (!isNaN(score)) {
					updateGauge(score);
					updateScoreDisplay(score, benchmarkData);
				}
			}

			// Used by benchmark-compare.js (View Results "Compare" control).
			window.CRFGauge = {
				setPeerBands: function(p33, p66, tooltip, source) {
					applyBenchmarkBands({ belowAverage: p33, average: p66, aboveAverage: p66 }, tooltip, source);
				},
				resetBands: function() {
					if (globalBenchmarkData) {
						applyBenchmarkBands(globalBenchmarkData);
					}
				}
			};

			function renderCompletedScoreFallback() {
				return fetchCompletedProjectScore().then(function(completedScore) {
					if (completedScore !== null && !isNaN(completedScore)) {
						updateGauge(completedScore);
						hideGaugeLoader();
					}
					return completedScore;
				});
			}

			function fetchBenchmarkDataAndInitializeGauge() {
				if (GAUGE_DEBUG) /* console.log('[fetchBenchmark] Starting'); */ ;
				
				// Re-find the score selector in case the DOM has changed
				scoreSelector = findScoreSelector();
				
				if (!scoreSelector) {
					//console.error('No score selector found, cannot initialize gauge');
					return;
				}

				$.ajax({
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					data: {
						action: 'get_benchmark_data'
					},
					success: function(response) {
						if (response.success && response.data.frameworks && response.data.frameworks[0]) {
							const frameworkData = response.data.frameworks[0];
							const quantiles = frameworkData.stats.quantiles;

							benchmarkData = {
								belowAverage: parseFloat(quantiles.p33),
								average: parseFloat(quantiles.p66),
								aboveAverage: parseFloat(quantiles.p66)
							};
							globalBenchmarkData = benchmarkData;

							const belowAveragePercent = (benchmarkData.belowAverage / 5) * 100;
							const averagePercent = (benchmarkData.average / 5) * 100;

							const ranges = [
								belowAveragePercent,
								averagePercent - belowAveragePercent,
								100 - averagePercent
							];
							gaugeDataPlugin.ranges = ranges;

							// Re-find the selector again in case DOM changed during AJAX
							scoreSelector = findScoreSelector();
							if (!scoreSelector) {
								//console.error('Score selector lost after AJAX');
								return;
							}

							fetchCompletedProjectScore().then(function(completedScore) {
								scoreSelector = findScoreSelector();
								const scoreElement = $(scoreSelector);
								const initialScoreText = scoreElement.text();
								const initialScore = completedScore !== null ? completedScore : parseFloat(initialScoreText);
								
								if (!isNaN(initialScore)) {
									//console.log('[fetchBenchmark] Initial score:', initialScore);
									updateGauge(initialScore);
									updateScoreDisplay(initialScore, benchmarkData);
								} else {
									//console.error('Initial score is NaN! Raw text:', `"${initialScoreText}"`);
								}

								// Set up the observer AFTER the initial fetch and update
								initializeScoreObserver();
							});
						} else {
							//console.error('Failed to parse benchmark data:', response.data);
							renderCompletedScoreFallback();
						}
					},
					error: function(error) {
						//console.error('Error fetching benchmark data:', error);
						renderCompletedScoreFallback();
					}
				});
			}

			function initializeScoreObserver() {
				if (!scoreSelector) {
					//console.error('No scoreSelector set, cannot initialize observer');
					return;
				}
				
				const observerTarget = document.querySelector(scoreSelector);
				
				if (observerTarget) {
					const observer = new MutationObserver(function(mutations) {
						mutations.forEach(function(mutation) {
							const newScoreText = $(mutation.target).text();
							const newScore = parseFloat(newScoreText);
							
							if (!isNaN(newScore) && benchmarkData) {
								//console.log('[MutationObserver] Score changed to:', newScore);
								updateGauge(newScore);
								updateScoreDisplay(newScore, benchmarkData);
							}
						});
					});

					observer.observe(observerTarget, {
						childList: true,
						characterData: true,
						subtree: true
					});
					if (GAUGE_DEBUG) /* console.log('[initializeScoreObserver] Observer attached'); */ ;
				} else {
					//console.error('Could not find observer target:', scoreSelector);
				}
			}

			// Function to read score from the currently visible card
			function readScoreFromVisibleCard() {
				const $visibleCard = getVisibleGaugeCard();
				
				// Look for score elements in the visible card using our priority list
				const scoreSelectors = [
					'.crf-maturitylevel-overall',
					'.crf-domain-overall',
					'.crf-legacy-domain-overall',
					'.core-functions-overall-value',
					'.audit-overall-value',
					'[class*="-overall-value"]'
				];
				
				let scoreText = null;
				
				for (let i = 0; i < scoreSelectors.length; i++) {
					const selector = scoreSelectors[i];
					const $element = $visibleCard.find(selector);
					if ($element.length > 0) {
						scoreText = $element.first().text().trim();
						break;
					}
				}
				
				// If not found in visible card, also check globally
				if (scoreText === null) {
					for (let i = 0; i < scoreSelectors.length; i++) {
						const selector = scoreSelectors[i];
						const $elements = $(selector).filter(':visible');
						if ($elements.length > 0) {
							scoreText = $elements.first().text().trim();
							break;
						}
					}
				}
				
				if (scoreText === null || scoreText === '') {
					return null;
				}
				
				const score = parseFloat(scoreText);
				return isNaN(score) ? null : score;
			}

			// Track the last visible card to detect changes
			let lastVisibleCardElement = null;

			// Function to handle when a different card becomes visible
			function handleVisibleCardChange(retryCount = 0) {
				const maxRetries = 5;
				const retryDelay = 300;
				
				const $visibleCard = getVisibleGaugeCard();
				const currentVisibleElement = $visibleCard[0];
				
				// Always try to update if card changed or on first attempt
				if (lastVisibleCardElement !== currentVisibleElement || retryCount > 0) {
					if (lastVisibleCardElement !== currentVisibleElement) {
						if (GAUGE_DEBUG) /* console.log('[handleVisibleCardChange] Card changed'); */ ;
						lastVisibleCardElement = currentVisibleElement;
					}
					
					// Read score from the new visible card
					const score = readScoreFromVisibleCard();
					if (score !== null && benchmarkData) {
						//console.log('[handleVisibleCardChange] Updating gauge with score:', score);
						updateGauge(score);
						updateScoreDisplay(score, benchmarkData);
						hideGaugeLoader();
					} else if (retryCount < maxRetries) {
						setTimeout(() => handleVisibleCardChange(retryCount + 1), retryDelay);
					} else {
						hideGaugeLoader();
					}
				} else {
					hideGaugeLoader();
				}
			}

			// The "Compare with peers" fields (benchmark-compare.js) only take effect on
			// Compare, which re-bands the gauge itself via window.CRFGauge.
			function isBenchmarkCompareField(target) {
				return $(target).closest('.benchmark-compare').length > 0;
			}

			// Listen for select/select2 changes that might trigger card visibility changes
			$(document).on('change', 'select', function(e) {
				if (isBenchmarkCompareField(e.target)) {
					return;
				}
				if (GAUGE_DEBUG) /* console.log('[select change] Detected'); */ ;
				showGaugeLoader();
				setTimeout(() => handleVisibleCardChange(0), 500);
			});

			// Also listen for select2 specific events
			$(document).on('select2:select', function(e) {
				if (isBenchmarkCompareField(e.target)) {
					return;
				}
				if (GAUGE_DEBUG) /* console.log('[select2:select] Detected'); */ ;
				showGaugeLoader();
				setTimeout(() => handleVisibleCardChange(0), 500);
			});

			// Initial benchmark fetch: on Web Assessment project pages, defer until controls init finishes
			// or fallback timeout — avoids stacking get_benchmark_data on the same burst as
			// initializeControls (api_action, get_current_user_id, fetch_project_data, etc.) → WAF 429.
			(function scheduleBenchmarkFetch() {
				var ran = false;
				function once() {
					if (ran) {
						return;
					}
					ran = true;
					fetchBenchmarkDataAndInitializeGauge();
				}
				if ($('#layoutSidenav_nav.project-menu').length) {
					$(window).one('crfProjectControlsReady', once);
					setTimeout(once, 12000);
				} else {
					once();
				}
			})();

			// Store the initial visible card
			lastVisibleCardElement = getVisibleGaugeCard()[0];
		}
	});
})(jQuery);
